import { useState } from "react";
import { Table, Button, Alert, Spin } from "antd";
import { useIntl } from "react-intl";
import { useSelector } from "react-redux";
import Header from "./components/Header";
import { CheckOutlined } from "@ant-design/icons";
import getDayCenterPatientColumns from "./components/columns";
import moment from "moment";
import OrderDetails from "./components/OrerDetails";
import useDayCenterPatientData from "./components/useDayCenterPatientData";
import { usePermission } from "../../hooks/accessControl";

const DayCenterPatient = (props) => {
  let { record } = props;
  const intl = useIntl();
  const activeDate = useSelector((state) => state.dayCenterPatient.activeDate);
  const loading = useSelector(
    (state) => state.pendingActions["daycenterpatient/update_records"]
  );
  const [selectedOrder, setSelectedOrder] = useState(record?.order_id);

  const scopePrefix = `branches/${record?.patient?.branch}/`;
  const {
    changes,
    isLoading,
    data,
    handleChanges,
    updateServer,
    onChange,
    effectiveOrders,
    filteredData,
  } = useDayCenterPatientData(record, activeDate, scopePrefix, selectedOrder);
  const hasEditorPermission = usePermission(
    record?.patient?.branch,
    "day_center",
    "editor"
  );

  const columns = getDayCenterPatientColumns(
    intl,
    handleChanges,
    changes,
    effectiveOrders,
    hasEditorPermission
  );

  const effectiveOrder = effectiveOrders?.find((i) => i.id === selectedOrder);
  const isActiveDateAfterCurrentMonth = moment(activeDate).isAfter(
    moment(),
    "month"
  );
  return (
    <div style={{ display: "flex", flexDirection: "column" }}>
      <Header
        record={record}
        effectiveOrders={effectiveOrders}
        onOrderChange={setSelectedOrder}
        selectedOrder={selectedOrder}
        filteredData={filteredData}
      />
      <div
        style={{
          flexGrow: 1,
          display: "flex",
          overflow: "hidden",
          paddingTop: "10px",
        }}
      >
        <div style={{ flex: "2 0 66%", overflow: "auto" }}>
          <Table
            id={"dayCenterTableRef"}
            bordered
            columns={columns}
            dataSource={filteredData}
            rowKey={(record) => `${record.date}`}
            scroll={{ y: "calc(100vh - 260px)" }}
            onChange={onChange}
            pagination={false}
            loading={isLoading}
          />
        </div>
        <div style={{ flex: "1 0 33%", overflow: "auto", padding: "0 20px" }}>
          {isLoading ? (
            <Spin />
          ) : effectiveOrders?.length > 0 ? (
            <OrderDetails order={effectiveOrder} />
          ) : (
            <Alert
              message={intl.formatMessage({
                id: "app.forms.order.no_day_center_orders",
              })}
              type="warning"
            />
          )}
        </div>
      </div>
      <div style={{ padding: "16px" }}>
        <Button
          type="primary"
          onClick={updateServer}
          icon={<CheckOutlined />}
          disabled={
            Object.keys(changes).length === 0 ||
            isActiveDateAfterCurrentMonth ||
            !selectedOrder ||
            !hasEditorPermission
          }
          loading={loading}
        >
          {" " + intl.formatMessage({ id: "app.actions.saveChanges" })}
        </Button>
      </div>
    </div>
  );
};

export default DayCenterPatient;
